import { render, staticRenderFns } from "./categoryDcaLocaltion.vue?vue&type=template&id=6c87700f&scoped=true&"
import script from "./categoryDcaLocaltion.vue?vue&type=script&lang=js&"
export * from "./categoryDcaLocaltion.vue?vue&type=script&lang=js&"
import style0 from "./categoryDcaLocaltion.vue?vue&type=style&index=0&id=6c87700f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87700f",
  null
  
)

export default component.exports